import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { DatosCompradorContext } from "../context/Context";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useHotkeys } from "react-hotkeys-hook";
import { styles } from "../theme/styles";
import { styled } from "@mui/material/styles";
import { Creators as StoresCreators } from "../store/ducks/stores";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  Card,
  TextField,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Grid,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from "@mui/material";
import Swal from "sweetalert2";
import { encodeData } from "../helpers/encode";

const columnWidth = 100 / 4;

const PdfsTable = (props) => {
  const { pdfsV } = props; // este es el json
  const [filtroEstatus, setFiltroEstatus] = useState("");
  const [filtroEspecies, setFiltroEspecies] = useState("");
  const [filteredPdfsV, setFilteredPdfsV] = useState(pdfsV);
  const [folioFiltro, setFolioFiltro] = useState("");
  const [folioFiltro2, setFolioFiltro2] = useState("");
  const [resetFilters, setResetFilters] = useState(false);
  const navigate = useNavigate();
  const formatoFolio = (folio) => {
    return folio.replace(/([a-zA-Z])([0-9]+)/g, "$1_$2");
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#00205b",
      color: theme.palette.common.white,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: "#dcffef",
    },
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const {
    correoCompradorContext,
    setCorreoCompradorContext,
    tiendaAsociadaContext,
    setTiendaAsociadaContext,
    rolContext,
    setRolContext,
    idGeneradoContext,
    setIdGeneradoContext,
    idbuscadoContext,
    setIdbuscadoContext,
  } = useContext(DatosCompradorContext);

  useEffect(() => {
    if (rolContext === "ADMIN") {
      setFilteredPdfsV(pdfsV);
    } else {
      if (pdfsV.length > 0) {
        if (tiendaAsociadaContext) {
          setFilteredPdfsV(
            pdfsV.filter((pdf) => pdf.tiendaAsociada === tiendaAsociadaContext)
          );
        }
      }
    }
  }, [pdfsV, tiendaAsociadaContext]);

  const handleFiltro = (e) => {
    setFiltroEstatus(e.target.value);
    aplicarFiltros(e.target.value, folioFiltro, filtroEspecies);
  };

  const handleFolioFiltro = (e) => {
    setFolioFiltro(e.target.value);
    aplicarFiltros(filtroEstatus, e.target.value, filtroEspecies);
  };

  const handleEspecies = (e) => {
    setFiltroEspecies(e.target.value);
    aplicarFiltros(filtroEstatus, folioFiltro, e.target.value);
  };

  const aplicarFiltros = (estatusContrato, folio, especie) => {
    let filteredPdfs = pdfsV;

    if (estatusContrato) {
      filteredPdfs = filteredPdfs.filter(
        (pdf) => pdf.estatusContrato === estatusContrato
      );
    }

    if (folio) {
      filteredPdfs = filteredPdfs.filter((pdf) => pdf.folio.startsWith(folio));
    }

    if (especie) {
      filteredPdfs = filteredPdfs.filter((pdf) => pdf.especie === especie);
    }

    setFilteredPdfsV(filteredPdfs);
  };

  useEffect(() => {
    if (resetFilters) {
      setFiltroEstatus(""); // resetear filtro a "Todos"
      setFiltroEspecies(""); // resetear filtro2 a "Todas"
      setResetFilters(false); // resetear resetFilters a false
    }
  }, [resetFilters]);

  return (
    <div>
      <TableContainer style={{ marginBottom: "20px", maxHeight: "400px" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell
                align="center"
                style={{ width: columnWidth, display: "row" }}>
                {rolContext === "ADMIN" ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center", // Centra el contenido horizontalmente
                      alignItems: "middle", // Alinea verticalmente el contenido en el centro
                      width: "100%", // Asegura que el contenedor ocupe todo el espacio disponible
                      marginBottom: "20px", // Añade un margen en la parte inferior, si es necesario
                    }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center", // Alinea verticalmente el ícono y el texto
                        marginRight: "10px", // Espacio entre el ícono y el texto
                      }}>
                      {rolContext === "ADMIN" ? (
                        <>
                          <svg
                            onClick={(e) => {
                              e.preventDefault();
                              Swal.fire({
                                icon: "info",
                                text: "- Dar dos clicks sobre un folio para visualizarlo.\n- Si un folio tiene un estado (Estado no finalizado) no se podrá visualizar.\n- Los folios no finalizados son aquellos que no completaron el formulario o que no se añadieron las firmas.",
                                title: "Recuerda que ...",
                                iconColor: "red",
                                confirmButtonText: "Aceptar",
                                confirmButtonColor: "#00205B",
                              });
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon icon-tabler icon-tabler-alert-circle-filled"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="#ff2825" // Borde rojo
                            fill="#ff2825" // Relleno rojo
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            style={{
                              marginRight: "10px", // Ajusta el espacio entre el ícono y el texto
                              borderRadius: "50%", // Hace el borde redondeado para que se vea como círculo
                              backgroundColor: "white", // Fondo blanco
                              padding: "1px", // Añadir espacio entre el borde y el icono
                              cursor: "pointer",
                            }}>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path
                              d="M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"
                              strokeWidth="0"
                              fill="#00205b"
                            />
                          </svg>
                          <span>Folio Tienda:</span>
                        </>
                      ) : (
                        <span>Folio:</span>
                      )}
                    </div>

                    {rolContext === "ADMIN" && (
                      <FormControl style={{ height: "10px" }}>
                        {pdfsV && (
                          <Select
                            style={{
                              height: "25px",
                              color: "white",
                              width: "auto",
                            }}
                            sx={{
                              "& .MuiSelect-select": {
                                paddingLeft: 3,
                              },
                              "& .MuiSvgIcon-root": {
                                color: "white",
                                position: "absolute",
                                left: "0px",
                              },
                            }}
                            value={folioFiltro}
                            onChange={handleFolioFiltro}>
                            <MenuItem value="">Todas</MenuItem>
                            {Array.from(
                              new Set(pdfsV.map((pdf) => pdf.tiendaAsociada))
                            )
                              .filter(
                                (tienda) =>
                                  rolContext === "ADMIN" ||
                                  tienda === tiendaAsociadaContext
                              )
                              .map((tienda) => (
                                <MenuItem key={tienda} value={tienda}>
                                  {tienda}
                                </MenuItem>
                              ))}
                          </Select>
                        )}
                      </FormControl>
                    )}
                  </div>
                ) : (
                  <span>Folio:</span>
                )}
              </StyledTableCell>
              <StyledTableCell align="center" style={{ width: columnWidth }}>
                <FormControl style={{ height: "10px", display: "inline" }}>
                  Estatus Contrato:
                  <Select
                    style={{ height: "25px", color: "white" }}
                    sx={{
                      "& .MuiSelect-select": {
                        paddingLeft: 3,
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                        position: "absolute",
                        left: "0px",
                      },
                    }}
                    value={filtroEstatus}
                    onChange={handleFiltro}>
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="Incompleto">Incompleto</MenuItem>
                    <MenuItem value="Finalizado">Finalizado</MenuItem>
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell align="center" style={{ width: columnWidth }}>
                Especie:
                <FormControl>
                  <Select
                    style={{ height: "25px", color: "white" }}
                    value={filtroEspecies}
                    sx={{
                      "& .MuiSelect-select": {
                        paddingLeft: 3,
                      },
                      "& .MuiSvgIcon-root": {
                        color: "white",
                        position: "absolute",
                        left: "0px",
                      },
                    }}
                    onChange={handleEspecies}>
                    <MenuItem value="">Todas</MenuItem>
                    <MenuItem value="Aves">Aves</MenuItem>
                    <MenuItem value="Pequeños Mamiferos">
                      Pequeños Mamiferos
                    </MenuItem>
                    <MenuItem value="Reptiles">Reptiles</MenuItem>
                  </Select>
                </FormControl>
              </StyledTableCell>
              <StyledTableCell align="center" style={{ width: columnWidth }}>
                Fecha
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody
            style={{
              overflow: "scroll",
            }}>
            {filteredPdfsV && filteredPdfsV.length > 0 ? (
              filteredPdfsV.map((pdf, index) => (
                <StyledTableRow
                  style={{ cursor: "pointer" }}
                  align="-webkit-center"
                  key={index}
                  onDoubleClick={() => {
                    if (pdf.estatusContrato !== "Finalizado") {
                      Swal.fire({
                        icon: "error",
                        text: "El folio seleccionado no fue finalizado.",
                        title: "Error",
                        iconColor: "red",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: "#00205B",
                      });
                      return;
                    }

                    setIdbuscadoContext(pdf.folio.replace(/_(?=[^_]*$)/, ""));
                    encodeData(
                      "IDBUSCADO",
                      pdf.folio.replace(/_(?=[^_]*$)/, "")
                    );
                    navigate("/pdfViewer2");
                  }}>
                  <StyledTableCell
                    style={{ width: columnWidth, textAlign: "center" }}>
                    {pdf.folio.replace(/_(?=[^_]*$)/, "")}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{
                      color:
                        pdf.estatusContrato === "Incompleto"
                          ? "red"
                          : pdf.estatusContrato === "Finalizado"
                          ? "green"
                          : "black",
                      width: columnWidth,
                    }}>
                    {pdf.estatusContrato}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ width: columnWidth }}>
                    {pdf.especie}
                  </StyledTableCell>
                  <StyledTableCell
                    align="center"
                    style={{ width: columnWidth }}>
                    {`${new Date(pdf.fechaRegistro).getDate()}/${
                      new Date(pdf.fechaRegistro).getMonth() + 1
                    }/${new Date(pdf.fechaRegistro).getFullYear()} ${new Date(
                      pdf.fechaRegistro
                    ).getHours()}:${String(
                      new Date(pdf.fechaRegistro).getMinutes()
                    ).padStart(2, "0")}`}
                  </StyledTableCell>
                </StyledTableRow>
              ))
            ) : (
              <StyledTableRow>
                <StyledTableCell
                  onClick={(e) => {
                    e.preventDefault();
                  }}
                  colSpan={4}
                  style={{ textAlign: "center" }}>
                  No hay datos{" "}
                </StyledTableCell>
              </StyledTableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default PdfsTable;
